import axios, { AxiosInstance } from 'axios';
import Vue from 'vue';
import io from 'socket.io-client';
import { Store } from 'vuex';
import { CheeersRootState } from '@/store';

export class Authentication {
  constructor(
    protected loginApi: string,
    protected logoutApi: string,
    protected checkAuthApi: string,
    protected axiosInstance: AxiosInstance = axios,
    protected store: Store<CheeersRootState>,
  ) {}

  setAxios(axiosInstance: AxiosInstance): this {
    this.axiosInstance = axiosInstance;
    return this;
  }

  async login(username: string, password: string): Promise<boolean> {
    try {
      await this.axiosInstance.post(this.loginApi, {
        username,
        password,
      });
      Vue.prototype.$cheeers.socket = io('/staff');
      Vue.prototype.$cheeers.initSocket(this.store);
      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  async logout(): Promise<boolean> {
    try {
      await this.axiosInstance.get(this.logoutApi);
      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  async isAllow(action = ''): Promise<boolean> {
    return this.axiosInstance.post(this.checkAuthApi, { action });
  }
}

export default function BootstrapAuthentication(
  loginApi: string,
  logoutApi: string,
  checkAuthApi: string,
  axiosInstance: AxiosInstance = axios,
  store: Store<CheeersRootState>,
): Authentication {
  const auth = new Authentication(
    loginApi,
    logoutApi,
    checkAuthApi,
    axiosInstance,
    store,
  );
  Vue.prototype.$auth = auth;
  return auth;
}
